"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRUD_AGGREGATE_ALIAS_RE = exports.DEFAULT_CRUD_AGGREGATE_LIMITS = exports.CrudHavingOperators = exports.CrudExtractParts = exports.CrudTimeBucketIntervals = exports.CrudAggregateFunctions = void 0;
/**
 * AST агрегационного запроса `q.<entity>.aggregate`.
 *
 * Перенос семантики агрегации OmniFlow 1 (ERA `readEntity {groupby, aggr}` в
 * польской записи) на объектную форму, консистентную с `CrudFilterAst`:
 * - условные агрегаты `['sum', ['integer', <cond>]]` → `where: CrudFilterAst`
 *   на агрегате (SQL `FILTER (WHERE ...)`);
 * - время-бакеты `['concat', toYYYYMMDD, ..., ddiv(minute,10)]` → первоклассный
 *   `timeBucket` (SQL `date_bin`);
 * - HAVING (в OmniFlow 1 отсутствовал — фильтровали на клиенте) — `having` по
 *   алиасам агрегатов.
 *
 * Дизайн-решения и план эпика — `docs/todo-crud-aggregate.md`.
 */
/**
 * Агрегатные функции. `count` без `field` — `COUNT(*)`; с `field` —
 * `COUNT(col)` (не считает NULL). `count_distinct` требует `field`.
 *
 * Результаты `count`/`count_distinct`/`sum`/`avg` приводятся к float8 на
 * SQL-уровне (иначе pg вернёт bigint/numeric строкой). `min`/`max` сохраняют
 * тип колонки (timestamptz нормализуется в ISO-строку на runtime-слое).
 */
exports.CrudAggregateFunctions = [
    'count',
    'count_distinct',
    'sum',
    'avg',
    'min',
    'max',
];
/**
 * Интервалы время-бакета. Enum, не free-string — `interval` участвует в SQL
 * (через параметр), и закрытый список снимает вопрос валидации.
 *
 * Sub-day интервалы компилируются в `date_bin`, `1d` — в `date_trunc('day', ...)`
 * с учётом `tz` (локальная полночь, не UTC-полночь).
 */
exports.CrudTimeBucketIntervals = ['1m', '5m', '10m', '15m', '30m', '1h', '1d'];
/**
 * Части даты для `extract`-группировки (профиль «по часам суток» / «по дням
 * недели» / «по календарным дням»).
 *
 * - `hour` — 0..23 (в `tz`, default UTC).
 * - `dow` — ISO day of week, 1=понедельник .. 7=воскресенье.
 * - `date` — строка `YYYY-MM-DD` (в `tz`).
 */
exports.CrudExtractParts = ['hour', 'dow', 'date'];
/**
 * Операторы HAVING — числовое подмножество filter-операторов (агрегаты
 * числовые; like/in по ним не имеют смысла в v1). Значения совпадают с
 * `CrudFilterOp` — это позволяет компилировать HAVING тем же `applyFilter()`.
 */
exports.CrudHavingOperators = ['eq', 'neq', 'gte', 'lte', 'gt', 'lt'];
exports.DEFAULT_CRUD_AGGREGATE_LIMITS = {
    maxGroupByKeys: 5,
    maxAggregates: 20,
    maxHavingDepth: 3,
    maxHavingLeaves: 20,
    maxGroups: 10_000,
};
/**
 * Алиас результирующей колонки (ключи `groupBy`/`aggr`, ссылки из
 * `having`/`orderBy`). Узкий алфавит — алиас уходит в SQL как quoted
 * идентификатор, regex делает injection невозможным by construction.
 * Ведущая буква (не `_`) — зарезервировано под служебные колонки билдера
 * (`__total`).
 */
exports.CRUD_AGGREGATE_ALIAS_RE = /^[a-zA-Z][a-zA-Z0-9_]{0,40}$/;
//# sourceMappingURL=aggregate-types.js.map